<ion-button
  class="button-wrapper button-loading"
  (click)="emitClick()"
  [disabled]="isDisabled || isLoading"
>
  {{ buttonText }}
  <ion-spinner *ngIf="isLoading" class="spinner"></ion-spinner>
</ion-button>
